import React from 'react'
import { Link } from '@morningtrain/react-navigation'
import Button from 'ui/buttons/Button'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import TableHeader from 'ui/table/TableHeader'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Card } from 'ui/cards'
import { EnumFilter, PaginationFilter, SearchFilter } from '@morningtrain/react-filters'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import ResourceFilter from 'support/filters/ResourceFilter'
import AdminPage from 'pages/app/AdminPage'
import { PageHeader, ButtonWrap } from 'ui/layouts'
import TranslatedTitle from 'widgets/TranslatedTitle'

import SquareButton from 'ui/buttons/SquareButton'
import * as Icons from 'ui/icons'
import DeleteButton from 'ui/buttons/DeleteButton'
import * as Displays from 'support/displays'
import {useEnvValue} from "@morningtrain/react-helpers";

export default function Index () {
  const [selectedCategoryValue, setSelectedCategoryValue] = useEnvValue(
    'resources.api.users.users.select_all.filters.filter_categories.value',
    null
  )

  return (
    <AdminPage withGlobalDepartmentFilter={false}>
      <Translator namespace='inventory.item'>

        {/* Page header */}
        <PageHeader title={<TranslatedTitle name='index_title' />}>
          <Link route='app.inventory.item.create'>
            <Button>
              <Translation name='inventory.item.create_title' />
            </Button>
          </Link>
        </PageHeader>

        <Card>
          <Collection resourceName='inventory.item'>
            <SelectedDepartmentFilter />
            <TableHeader>
              <ResourceFilter
                label={<Translation name='filters.category.label' />}
                placeholder='Alle kategorier'
                name='inventory_category'
                optionsKey='name'
                resourceName='inventory.category'
                operationName='options'
                onChange={(categoryValue) => setSelectedCategoryValue(categoryValue)}
                defaultValue={selectedCategoryValue}
              />
              <SearchFilter
                label={<Translation name='filters.search.label' />}
              />
              <EnumFilter
                label={<Translation name='filters.status.label' />}
                name='inventory_item_status'
                enum='inventory_item_status'
              />
            </TableHeader>
            <Table>
              <Columns.Column
                name='image'
                label={<Translation name='image' />}
              >
                <div className='h-16 w-16'>
                  <Displays.Image
                    name='image'
                    className='h-full w-full object-contain block'
                    lazy
                  />
                </div>
              </Columns.Column>
              <Columns.Text name='category.name' label={<Translation name='columns.category.label' />} />
              <Columns.Text name='sku' label={<Translation name='columns.sku.label' />} />
              <Columns.Text name='name' label={<Translation name='columns.name.label' />} />
              <Columns.Number name='min_unit' label={<Translation name='columns.min_order.label' />} />
              <Columns.Currency name='price' label={<Translation name='columns.price.label' />} />
              <Columns.Currency name='unit_price' label={<Translation name='columns.unit_price.label' />} />
              <Columns.Text
                name='product_bought_amount'
                label={<Translation name='columns.product_bought_amount.label' />}
              />
              <Columns.Date name='expires_at' label={<Translation name='columns.expires_at.label' />} />
              <Columns.Column>
                <ButtonWrap className='my-0'>
                  <Link route='app.inventory.item.edit' parameters={{ inventory_item: 'model:id' }}>
                    <SquareButton color='btn-primary'>
                      <Icons.Pencil className='w-4 h-4' />
                    </SquareButton>
                  </Link>
                  <DeleteModelOnClick>
                    <DeleteButton />
                  </DeleteModelOnClick>
                </ButtonWrap>
              </Columns.Column>
            </Table>
            <PaginationFilter />
          </Collection>
        </Card>
      </Translator>
    </AdminPage>
  )
}
